import { render, staticRenderFns } from "./edit-saved-message.vue?vue&type=template&id=744a4e3c&scoped=true&"
import script from "./edit-saved-message.vue?vue&type=script&lang=js&"
export * from "./edit-saved-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a4e3c",
  null
  
)

export default component.exports